/**
 * Actions 命名空间
 */
export const actionsNamespace = 'fanfanlo/javajs/v1/project/components/actions/'
